import type { BaseCondition, ConditionHandler, OfferSystemConfig } from './offerSystemTypes';

export function getConditionHandler<S, C extends BaseCondition, GD>(
  config: OfferSystemConfig<S, C, GD>,
  type: Extract<C, 'type'>,
): ConditionHandler<S, C, GD> {
  return config.conditions[type] as unknown as ConditionHandler<S, C, GD>;
}
